import { combineReducers } from 'redux';

import auth from './auth';
import dbet from './dbet';
import games from './games';
import popup from './popup';
import error from './error';
import dialog from './dialog';
import uiState from './uiState';
import banners from './banners';

const reducers = {
  dbet,
  auth,
  error,
  games,
  popup,
  dialog,
  banners,
  uiState,
};

export default combineReducers(reducers);
